import { inject } from "@angular/core";
import { Observable, throwError } from "rxjs";

import { RechargeWalletService } from "@app/core/wallet/domain/service/recharge-wallet.service";
import { ApplyWalletRechargeWS } from "@app/core/wallet/infraestructure/webservice/apply-wallet-recharge.ws";
import { MissingCredentialsError } from "@app/core/shared/domain/missing-credentials.error";
import { TokenRepo } from "@app/core/shared/domain/token.repo";


export class RechargeWalletDataService implements RechargeWalletService {
  private readonly applyWalletRechargeWS = inject(ApplyWalletRechargeWS);
  private readonly tokenRepo = inject(TokenRepo);

  apply(amount: number): Observable<string> {
    const token = this.tokenRepo.get();

    if (token == null) {
      return throwError(() => new MissingCredentialsError());
    }
    return this.applyWalletRechargeWS.execute(amount, token);
  }
}
